import React, { useRef, useEffect, useState } from 'react';

// Parse tag from log entry bracket e.g. "[🏸]" → "🏸"
const parseTagEmoji = (entry) => {
  const match = entry.match(/\[([^\]]+)\]$/);
  return match ? match[1] : null;
};

const ScoreLogBar = ({ log, onOpenFull }) => {
  const listRef = useRef(null);
  const [visible, setVisible] = useState([]);

  useEffect(() => {
    const filtered = log.filter(e => 
      e.includes('得分') || e.startsWith('↩') || e.startsWith('↪') || 
      e.startsWith('─') || e.startsWith('↔') || e.startsWith('🏆') || 
      e.startsWith('🎯'));
    setVisible(filtered.slice(-6));
  }, [log]);

  useEffect(() => {
    if (listRef.current) listRef.current.scrollLeft = listRef.current.scrollWidth;
  }, [visible]);

  return (
    <div className="shrink-0 border-t border-white/[0.07] bg-black/50 backdrop-blur-sm" style={{ height: 36 }}>
      <div className="flex items-center gap-1.5 px-2 h-full">
        <span className="text-[9px] font-black text-white/30 shrink-0">📋</span>
        
        <div ref={listRef} className="flex-1 flex items-center gap-1 overflow-x-auto"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          
          {visible.length === 0 && (
            <span className="text-[10px] text-white/25 font-bold whitespace-nowrap">尚無記錄</span>
          )}
          
          {visible.map((entry, i) => {
            const isSep = entry.startsWith('─') || entry.startsWith('↔') || entry.startsWith('🏆') || entry.startsWith('🎯');
            const isUndo = entry.startsWith('↩');
            const isLet = entry.startsWith('🔄');
            const isDispute = entry.startsWith('⚖️');
            const isLast = i === visible.length - 1;
            const tagEmoji = (!isSep && !isUndo) ? parseTagEmoji(entry) : null;
            
            let bgColor = isLast && !isSep && !isUndo ? 'bg-white/15' : '';
            let textColor = '';
            
            if (isUndo) {
              bgColor = 'bg-amber-500/15';
              textColor = 'text-amber-200';
            } else if (isLet || isDispute) {
              bgColor = 'bg-purple-500/15';
              textColor = 'text-purple-200';
            } else if (isSep) {
              textColor = 'text-white/25';
            } else if (isLast) {
              textColor = 'text-white';
            } else {
              textColor = 'text-white/40';
            }
            
            return (
              <div key={i} className={`shrink-0 flex items-center gap-1 px-2 py-0.5 rounded-lg text-[10px] font-black whitespace-nowrap ${bgColor} ${textColor} ${isLast && !isSep && !isUndo ? 'border border-white/25' : ''}`}>
                {!isSep && !isUndo && (
                  <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${isLast ? 'bg-emerald-400' : 'bg-white/25'}`} />
                )}
                {tagEmoji ? (
                  <>
                    {entry.replace(/\s*\[[^\]]+\]$/, '')}
                    <span className="text-[10px]">{tagEmoji}</span>
                  </>
                ) : entry}
              </div>
            );
          })}
        </div>
        
        <button onClick={onOpenFull}
          className="shrink-0 text-[9px] font-black text-white/40 active:text-white transition-colors px-1.5 py-0.5 rounded-md border border-white/10 bg-white/5">
          全部
        </button>
      </div>
    </div>
  );
};

export default ScoreLogBar;